export default "__VITE_ASSET__BYeiE7Jx__"